import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditCityButton from './EditCityButton';
import DeleteCityButton from './DeleteCityButton';
const CityToolbar = ({ cityId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditCityButton cityId={cityId} />{' '}
      <DeleteCityButton cityId={cityId} />
    </div>
  </ButtonToolbar>
);

CityToolbar.propTypes = {
  cityId: PropTypes.number.isRequired,
};

export default CityToolbar;